// GraphQL queries and mutations for Features (proxy membership API)

export const listFeaturesQuery = `
  query ListFeatures($input: ListFeaturesInput) {
    listFeatures(input: $input) {
      code
      featureList {
        featureCode
        name
        description
        isActive
        createdAt
        updatedAt
      }
    }
  }
`;

export const getFeatureQuery = `
  query GetFeature($input: GetFeatureInput!) {
    getFeature(input: $input) {
      code
      feature {
        featureCode
        name
        description
        isActive
        createdAt
        updatedAt
      }
    }
  }
`;

export const getPlanFeaturesQuery = `
  query GetPlanFeatures($input: GetPlanFeaturesInput!) {
    getPlanFeatures(input: $input) {
      code
      featureList {
        featureCode
        name
        description
        isActive
        createdAt
        updatedAt
      }
    }
  }
`;

export const createFeatureMutation = `
  mutation CreateFeature($input: CreateFeatureInput!) {
    createFeature(input: $input) {
      code
      feature {
        featureCode
        name
        description
        isActive
        createdAt
        updatedAt
      }
    }
  }
`;

export const updateFeatureMutation = `
  mutation UpdateFeature($featureCode: String!, $input: UpdateFeatureInput!) {
    updateFeature(featureCode: $featureCode, input: $input) {
      code
      feature {
        featureCode
        name
        description
        isActive
        createdAt
        updatedAt
      }
    }
  }
`;

export const addPlanFeatureMutation = `
  mutation AddPlanFeature($input: AddPlanFeatureInput!) {
    addPlanFeature(input: $input) {
      code
      planFeature {
        planFeatureId
        planId
        featureCode
        included
      }
    }
  }
`;

export const deletePlanFeatureMutation = `
  mutation DeletePlanFeature($planId: String!, $featureCode: String!) {
    deletePlanFeature(planId: $planId, featureCode: $featureCode) {
      code
      message
    }
  }
`;
